import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import DocumentTitle from "react-document-title";
import SearchCriteria from "../../Utils/SearchCriteria";
// import SearchResults from '../../Utils/SearchResults';
import { Container, Alert } from "reactstrap";
import errors from "../../Constants/errors.json";
import ViewAdminForm from "./ViewAdminForm";
import Mapping from "../../Utils/Mapping";
import {
  getAdminUserDetails,
  errorWhileFetch,
  setUserList,
} from "../../../actions/admin";
import { fetchComplete } from "../../../actions/request";
import { Loading } from "../../../loader/Loading";
import InfiniteScrollTable from "../../Common/InfiniteScrollCognito";
import { enAPI } from "../../../config";

function ViewAdminSearch() {
  const dispatch = useDispatch();

  // const [property, setProperty] = useState(undefined);
  const [modal, openModal] = useState(false);
  const { userDetails, usersList, searchAttributes, lastKey } = useSelector(
    (state) => state?.admin
  );

  const isLoading = useSelector((state) => state?.fetch?.isLoading);
  const error = useSelector((state) => state?.error?.error_obj);
  const authToken = useSelector((state) => state?.auth?.token);

  const fetchCompleteFn = () => {
    dispatch(fetchComplete());
  };

  const getAdminUserDetailsFn = (username) => {
    dispatch(getAdminUserDetails(username));
  };
  //dont name the function and action creator same. leads to infinite loop.

  const errorWhileFetchFn = (err) => {
    dispatch(errorWhileFetch(err));
  };

  const setUserListFn = (...props) => {
    dispatch(setUserList(...props));
  };

  useEffect(() => {
    dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
    dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });

    return () => {
      dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
      dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });
    };
  }, [dispatch]);

  useEffect(() => {
    if (userDetails !== undefined) {
      if (!modal) {
        openModal(!modal);
      }
    }
  }, [userDetails, modal]);

  // function PropertySet(value) {
  //   setProperty(value);
  // }

  function toggle() {
    openModal(!modal);
  }

  const cols = [
    {
      label: "UserName",
      dataKey: "email",
      width: "250",
      customCell: (props) => {
        const { rowData } = props;

        return (
          <div
            style={{
              backgroundColor: "none",
              borderColor: "none",
              color: "blue",
              cursor: "pointer",
            }}
            onClick={(e) => {
              // PropertySet(rowData);
              getAdminUserDetailsFn(rowData?.Username);
            }}
          >
            {rowData.email}
          </div>
        );
      },
    },
    {
      label: "First Name",
      dataKey: "given_name",
      width: "100",
    },
    {
      label: "Last Name",
      dataKey: "family_name",
      width: "100",
    },
  ];

  return (
    <DocumentTitle title={"Doorkeeper | View Admin"}>
      <Container style={{ padding: "0% 2%" }}>
        <h5 style={{ marginLeft: "42%" }}>View Admin</h5>

        {modal && !error && userDetails && (
          <ViewAdminForm
            modal={modal}
            toggle={toggle}
            userDetails={userDetails}
          />
        )}
        <SearchCriteria manageAdmin={true} />
        {isLoading && !error && <Loading />}
        {usersList && usersList.length > 0 && searchAttributes && !error && (
          // <SearchResults
          // 	columns={columns}
          // 	data={this.props.usersList}
          // 	tableHeight={'50vh'}
          // />

          <InfiniteScrollTable
            columnData={cols}
            data={usersList}
            gridClassName={"gridClass"}
            rowHeight={45}
            page={"viewSearch"}
            url={`${enAPI}ADMIN_PORTAL/searchusers`}
            lastKey={lastKey}
            authToken={authToken}
            searchAttributes={searchAttributes}
            errorWhileFetch={errorWhileFetchFn}
            fetchComplete={fetchCompleteFn}
            setUserList={setUserListFn}
          />
        )}
        {!error && usersList && usersList.length === 0 && !isLoading && (
          <Alert color="info" style={{ textAlign: "center" }}>
            <h6>No records found.</h6>
          </Alert>
        )}
        {error && (
          <Alert color="danger" style={{ textAlign: "center" }}>
            <h5>
              <Mapping dictionary={errors} word={error.errorPath} />
            </h5>
          </Alert>
        )}
      </Container>
    </DocumentTitle>
  );
}

// class ViewSearchAdmin extends React.Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       modal: false,
//       property: undefined,
//     };
//   }
//   return() {
//     const cols = [
//       {
//         label: "UserName",
//         dataKey: "email",
//         width: "250",
//         customCell: (props) => {
//           const { rowData } = props;

//           return (
//             <div
//               style={{
//                 backgroundColor: "none",
//                 borderColor: "none",
//                 color: "blue",
//                 cursor: "pointer",
//               }}
//               onClick={(e) => {
//                 this.PropertySet(rowData);
//                 this.props.getAdminUserDetails(rowData.Username);
//               }}
//             >
//               {rowData.email}
//             </div>
//           );
//         },
//       },
//       {
//         label: "First Name",
//         dataKey: "given_name",
//         width: "100",
//       },
//       {
//         label: "Last Name",
//         dataKey: "family_name",
//         width: "100",
//       },
//     ];
//     return (
//       <DocumentTitle title={"Doorkeeper | View Admin"}>
//         <Container style={{ padding: "0% 2%" }}>
//           <h5 style={{ marginLeft: "42%" }}>View Admin</h5>
//           {this.state.modal && !error && userDetails && (
//             <ViewUserDetails
//               modal={this.state.modal}
//               toggle={this.toggle}
//               userDetails={userDetails}
//             />
//           )}
//           <SearchCriteria manageAdmin={true} />
//           {isLoading && !error && <Loading />}
//           {usersList && usersList.length > 0 && searchAttributes && !error && (
//             // <SearchResults
//             // 	columns={columns}
//             // 	data={this.props.usersList}
//             // 	tableHeight={'50vh'}
//             // />

//             <InfiniteScrollTable
//               columnData={cols}
//               data={usersList}
//               gridClassName={"gridClass"}
//               rowHeight={45}
//               page={"viewSearch"}
//               url={`${enAPI}ADMIN_PORTAL/searchusers`}
//               lastKey={this.props.lastKey}
//               authToken={this.props.authToken}
//               searchAttributes={searchAttributes}
//               errorWhileFetch={this.props.errorWhileFetch}
//               fetchComplete={this.props.fetchComplete}
//               setUserList={this.props.setUserList}
//             />
//           )}
//           {!error && usersList && usersList.length === 0 && !isLoading && (
//             <Alert color="info" style={{ textAlign: "center" }}>
//               <h6>No records found.</h6>
//             </Alert>
//           )}
//           {error && (
//             <Alert color="danger" style={{ textAlign: "center" }}>
//               <h5>
//                 <Mapping dictionary={errors} word={error.errorPath} />
//               </h5>
//             </Alert>
//           )}
//         </Container>
//       </DocumentTitle>
//     );
//   }
// }

// const mapDistpatchToProps = (dispatch) => {
//   return {
//     clearError: () => {
//       dispatch({ type: "SET_ERROR", data: { error_obj: undefined } });
//     },
//     clearUsersList: () => {
//       dispatch({ type: "ADMIN_USERS_LIST", data: { usersList: undefined } });
//     },
//     getAdminUserDetails: (username) => dispatch(getAdminUserDetails(username)),
//     errorWhileFetch: (err) => dispatch(errorWhileFetch(err)),
//     setUserList: (...props) => dispatch(setUserList(...props)),
//   };
// };

// const mapStateToProps = (state) => {
//   return {
//     usersList: state.admin.usersList,
//     isLoading: state.fetch.isLoading,
//     error: state.error.error_obj,
//     userDetails: state.admin.userDetails,
//     authToken: state.auth.token,
//     searchAttributes: state.admin.searchAttributes,
//     lastKey: state.admin.lastKey,
//   };
// };

// export default connect(mapStateToProps, mapDistpatchToProps)(ViewSearchAdmin);

export default ViewAdminSearch;
